export default {
  type: "Feature",
  properties: {
    name: "Мөрөн",
    location: [49.04433, 99.679],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [99.0742778778076, 48.296270779257405],
        [99.0966796875, 48.35989909002194],
        [99.06372070312499, 48.494767515307295],
        [99.1021728515625, 48.63290858589532],
        [99.21203613281249, 48.76343113791796],
        [99.16259765625, 48.88639177703194],
        [99.1461181640625, 49.05227025601607],
        [99.1021728515625, 49.1170290407793],
        [98.97033691406249, 49.106241774469055],
        [98.800048828125, 49.1170290407793],
        [98.76708984374999, 49.03786794532644],
        [98.54736328125, 48.935130721045326],
        [98.4649658203125, 48.96939999849952],
        [98.42926025390625, 49.00094298321501],
        [98.36746215820312, 49.01985919086641],
        [98.29330444335938, 49.01625665778159],
        [98.19442749023438, 49.015355983769666],
        [98.13812255859375, 48.99824008113872],
        [98.09005737304688, 48.98652581047831],
        [97.90054321289062, 48.99733908118444],
        [97.85934448242188, 49.009050809382046],
        [97.76870727539062, 49.06576863405361],
        [97.66983032226562, 49.11343354595957],
        [97.52700805664062, 49.157460400911745],
        [97.40478515625, 49.17721484130587],
        [97.27294921875, 49.182601048138054],
        [97.174072265625, 49.167338606291075],
        [97.119140625, 49.224772722794825],
        [97.02850341796875, 49.28482762264301],
        [96.93374633789062, 49.32422691861083],
        [96.87881469726562, 49.36806633482156],
        [96.88156127929688, 49.439556958940855],
        [96.87538146972656, 49.508714260218404],
        [96.93168640136719, 49.542587974015504],
        [96.97425842285155, 49.57821916282],
        [97.03674316406249, 49.61827317596852],
        [97.0751953125, 49.64762521193305],
        [97.10334777832031, 49.68451251348889],
        [97.12944030761719, 49.74888708373188],
        [97.13630676269531, 49.78392421773299],
        [97.12971925735474, 49.79240250154501],
        [97.12970852851868, 49.79238864935048],
        [97.22900390625, 49.745781306155735],
        [97.3663330078125, 49.777716951563754],
        [97.5091552734375, 49.816720843571765],
        [97.57507324218749, 49.937079756975294],
        [97.7728271484375, 49.99714673955339],
        [97.8497314453125, 49.91232450346395],
        [97.88818359375, 49.92647191927194],
        [97.8826904296875, 49.986552130506176],
        [98.009033203125, 50.035973672195496],
        [98.0694580078125, 50.03950183762877],
        [98.118896484375, 50.138185230436896],
        [98.1793212890625, 50.169861746007314],
        [98.184814453125, 50.21557967003726],
        [98.30017089843749, 50.327929664466296],
        [98.2672119140625, 50.41901890273709],
        [98.3441162109375, 50.49595785216966],
        [98.228759765625, 50.55881484085447],
        [98.02001953125, 50.666872321810715],
        [97.943115234375, 50.80593472676908],
        [98.0364990234375, 50.86837814203458],
        [97.88818359375, 50.92381327191295],
        [97.833251953125, 51.01721046364217],
        [97.9541015625, 51.33061163769853],
        [98.06396484375, 51.45742980658965],
        [98.1243896484375, 51.47111882613948],
        [98.228759765625, 51.45400691005982],
        [98.23974609375, 51.600959780448605],
        [98.3660888671875, 51.7406361640977],
        [98.5308837890625, 51.80521825434942],
        [98.6846923828125, 51.83577752045248],
        [98.7615966796875, 51.87309959004367],
        [98.865966796875, 52.13348804077147],
        [98.9813232421875, 52.14360239845529],
        [99.06372070312499, 52.06262321411284],
        [99.26696777343749, 52.01531743663362],
        [99.283447265625, 51.957807388715544],
        [99.4482421875, 51.944264879028765],
        [99.755859375, 51.90361280788355],
        [99.86572265625, 51.77123920059794],
        [100.1513671875, 51.7508394806285],
        [100.65673828125, 51.72702815704774],
        [100.86547851562499, 51.59754765771458],
        [101.2554931640625, 51.5429188223739],
        [101.44226074218749, 51.44716034698012],
        [101.568603515625, 51.498484547170605],
        [101.6455078125, 51.47111882613948],
        [101.92565917968749, 51.406059404992746],
        [102.10693359375, 51.36492148825955],
        [102.183837890625, 51.29971080556154],
        [102.1234130859375, 51.27566243415853],
        [102.1563720703125, 51.10352194240416],
        [102.2332763671875, 50.968805734317804],
        [102.2113037109375, 50.8232885012118],
        [102.3431396484375, 50.719069112580804],
        [102.3101806640625, 50.666872321810715],
        [102.513427734375, 50.59369921413021],
        [102.6123046875, 50.49246334187725],
        [102.64509201049805, 50.41147127685875],
        [102.645263671875, 50.41114309193372],
        [102.50106811523438, 50.35772808048406],
        [102.41455078125, 50.29986701674912],
        [102.39532470703125, 50.2691545281742],
        [102.37884521484375, 50.217337177613686],
        [102.35687255859375, 50.18393346184497],
        [102.24838256835938, 50.11089141378986],
        [102.22091674804686, 50.08710669808234],
        [102.21817016601562, 50.07388786455134],
        [102.12753295898436, 50.004208515595614],
        [102.10418701171874, 49.96977255919705],
        [102.10281372070312, 49.92912409759547],
        [102.13302612304688, 49.90348026046574],
        [102.20718383789062, 49.8787077521734],
        [102.48596191406249, 49.80254124506291],
        [102.5628662109375, 49.786584231227586],
        [102.70843505859375, 49.742231602580716],
        [102.78482437133789, 49.69173115108819],
        [102.67822265625, 49.64362370314076],
        [102.64389038085938, 49.635619698841445],
        [102.57247924804686, 49.64273443429918],
        [102.53402709960938, 49.64184514921545],
        [102.5079345703125, 49.62672481765915],
        [102.48870849609375, 49.596470070892686],
        [102.40905761718749, 49.50024216453777],
        [102.29919433593749, 49.439556958940855],
        [102.1563720703125, 49.40739905889802],
        [102.00256347656249, 49.38594874941847],
        [101.8377685546875, 49.30363576187125],
        [101.788330078125, 49.24270720875383],
        [101.7169189453125, 49.2355341957325],
        [101.634521484375, 49.127813961593255],
        [101.63246154785156, 49.06351915895547],
        [101.6658067703247, 48.962750894091165],
        [101.66610717773438, 48.963089005540155],
        [101.60568237304686, 48.95948236523749],
        [101.53770446777344, 48.950915549215985],
        [101.44912719726561, 48.95407191575548],
        [101.36054992675781, 48.96939999849952],
        [101.28021240234375, 49.015355983769666],
        [101.14837646484375, 49.050920216584856],
        [100.94856262207031, 49.116130191506805],
        [100.88607788085938, 49.13095912169914],
        [100.70205688476562, 49.20503726723141],
        [100.64437866210938, 49.10444366870733],
        [100.535888671875, 49.034266715880854],
        [100.47683715820312, 48.9991410647952],
        [100.60317993164062, 48.95948236523749],
        [100.64163208007812, 48.923401616679705],
        [100.579833984375, 48.89271247049609],
        [100.48095703125, 48.866521538507754],
        [100.4315185546875, 48.823140892101684],
        [100.38619995117188, 48.75075629617738],
        [100.35736083984375, 48.675546901341384],
        [100.36148071289062, 48.629278127969414],
        [100.39581298828125, 48.58205840283824],
        [100.47546386718749, 48.50932644976633],
        [100.37796020507812, 48.4965876108066],
        [100.28182983398438, 48.4902169906863],
        [100.22552490234374, 48.4765629664158],
        [100.2117919921875, 48.45561965661709],
        [100.21041870117186, 48.412795581099964],
        [100.17196655273438, 48.390002110874164],
        [100.107421875, 48.38909015961602],
        [100.0469970703125, 48.40550278187468],
        [99.96185302734375, 48.44377831058805],
        [99.9041748046875, 48.463815894066066],
        [99.78607177734375, 48.486576276944774],
        [99.7833251953125, 48.420998730129426],
        [99.744873046875, 48.339820521006125],
        [99.70230102539062, 48.295985271707664],
        [99.61166381835938, 48.274967532852976],
        [99.35760498046875, 48.2420528380672],
        [99.26422119140625, 48.23565029755306],
        [99.22027587890624, 48.24571107288924],
        [99.1680908203125, 48.26674084583965],
        [99.07432079315186, 48.29617085179661],
        [99.0742778778076, 48.296270779257405],
      ],
    ],
  },
};
